import { render, staticRenderFns } from "./InvestigationSequenceForm.vue?vue&type=template&id=4bc357da&scoped=true&"
import script from "./InvestigationSequenceForm.vue?vue&type=script&lang=js&"
export * from "./InvestigationSequenceForm.vue?vue&type=script&lang=js&"
import style0 from "./InvestigationSequenceForm.vue?vue&type=style&index=0&id=4bc357da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc357da",
  null
  
)

export default component.exports